/* eslint-disable */

import { mapState, mapMutations, mapGetters } from 'vuex'
import { api } from "../request/api.js"

export default {
  name: 'LoginSuccess',
  computed: {
    ...mapState(['userInfo'])
},
  created() {
    let result = this.$route.query
    if (!result.token || result.token.length == 0) {
      this.go()
      return
    }

    api.appleLogin({
      app_id: Number(result.app_id),
      id_token: result.token
    }).then(d => {
      this.loginLocal(d)
      this.go()
    }).catch(e => {
      alert(e.msg || e || 'error')
    })
  },
  data() {
    return {
      
    }
  },
  methods: {
    ...mapMutations(['loginLocal', 'logout']),
    go() {
      window.location.href = '/pay'
    }
  }
}